import { LitElement, html, css } from 'lit';
import { customElement, state, query } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '@sdb-develop/learning-composition-player/src/store/store.js';
import {
    loadRegistrationInfo,
    updateRegistration,
    saveRegistrationInfo,
} from '@sdb-develop/learning-composition-player/src/store/registration/registration.js';
import { translate } from '@sdb-develop/learning-composition-player/src/helpers/translate.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
import '@polymer/iron-form/iron-form.js';
import '@polymer/paper-input/paper-input.js';
import '@sdb-develop/learning-frontend';
import '@sdb-develop/learning-composition-player/src/components/shared/sdb-spinner.js';

@customElement('sdb-registration-form')
class SdbRegistrationForm extends connect(store)(LitElement) {

    @state()
    accessor userReg = {};

    @state()
    accessor info = [];

    @state()
    accessor isDirty = false;

    @state()
    accessor isLoading = false;

    @query('#registration_form')
    accessor registrationForm;

    _debouncer;
    _firstValueChanged = false;

    stateChanged(state) {
        this.keys = state.env.registrationKeys;
        this.userReg = state.registration.current;
        this.info = state.registration.info;
        this.isDirty = state.registration.dirty;
        this.isLoading = state.registration.status === 'loading' || !state.registration.current;
    }

    static get styles() {
        return css`
            :host {
                display: block;
            }

            p.instruction {
                margin: 0 0 1rem;
            }

            div.buttons {
                margin-top: 20px;
                display: flex;
                justify-content: flex-end;
                gap: 0.5rem;
            }
        `;
    }

    render() {
        if (this.isLoading) {
            return html`<sdb-spinner></sdb-spinner>`;
        }

        if (this.info.length === 0) {
            return html`<div>${translate('warning_no_registration')}</div>`;
        }

        return html`
            <p class="instruction">${translate('registrationInstruction')}</p>
            <iron-form id="registration_form">
                <form>
                    ${this.info.map(
                        (reg) => html`
                            <div>
                                <paper-input
                                    label=${reg.displayName}
                                    value=${this._getValue(reg.key)}
                                    @value-changed=${(e) => { this._update(e, reg.key); }}>
                                </paper-input>
                            </div>`
                        )}
                    <div class="buttons" >
                        <sdb-content-button
                            label=${translate('save')}
                            ?light=${this.light}
                            ?disabled=${!this.isDirty}
                            ?hidden=${this.readonly}
                            @click=${() => { this._save(); }}>
                        </sdb-content-button>
                    </div>
                </form>
            </iron-form>
        `;
    }

    firstUpdated() {
        store.dispatch(loadRegistrationInfo());
    }

    _getValue(key) {
        return this.userReg.registrations.find((ur) => ur.registrationInfoKey === key)
            ?.registration;
    }

    _update(e, key) {
        if (this._getValue(key) === e.detail.value) {
            return;
        }

        this._debouncer = Debouncer.debounce(
            this._debouncer, // initially undefined
            timeOut.after(400),
            () => {
                store.dispatch(updateRegistration({
                    key: key,
                    changes: {
                        registrationInfoKey: key,
                        registration: e.detail.value,
                        lastModified: new Date(),
                    }
                }));
            }
        );
    }

    _save() {
        if (this.registrationForm.validate()) {
            store.dispatch(saveRegistrationInfo());
        }
    }
}
